import { reactive, readonly, ref } from 'vue';
import { UserState } from '@/composables/User';
import { getUserProfile, saveMyProfile } from '@/composables/user/Profile';
import { UsersUpdateInputItem } from '@/types/generated-types/graphql';

export interface OnboardingProfile {
  firstName: string;
  lastName: string;
  societe: string;
  vatNumber: string;
  rue: string;
  zipCode: string;
  city: string;
  country: string;
  phoneMobile: string;
}

const profile = reactive<OnboardingProfile>({
  firstName: '',
  lastName: '',
  societe: '',
  vatNumber: '',
  rue: '',
  zipCode: '',
  city: '',
  country: '',
  phoneMobile: '',
});

const loaded = ref(false);
const loading = ref(false);

const preload = async () => {
  if (loaded.value || loading.value) return;
  loading.value = true;
  try {
    profile.firstName = UserState.user.firstName ?? '';
    profile.lastName = UserState.user.lastName ?? '';
    profile.phoneMobile = UserState.user.phoneMobile ?? '';
    profile.country = UserState.user.country ?? '';
    const { id } = UserState.user;
    if (id) {
      const data: any = await getUserProfile(id);
      const u = data?.item ?? data?.data?.[0] ?? data?.[0] ?? data;
      if (u) {
        profile.firstName = u.first_name ?? profile.firstName;
        profile.lastName = u.last_name ?? profile.lastName;
        profile.societe = u.societe ?? '';
        profile.vatNumber = u.vat_number ?? '';
        profile.rue = u.rue ?? '';
        profile.zipCode = u.zip_code ?? '';
        profile.city = u.city ?? '';
        profile.country = u.country ?? profile.country;
        profile.phoneMobile = u.phone_mobile ?? profile.phoneMobile;
      }
    }
    loaded.value = true;
  } finally {
    loading.value = false;
  }
};

const saveProfile = async () => {
  const payload: UsersUpdateInputItem = {
    id_user: UserState.user.id,
    first_name: profile.firstName,
    last_name: profile.lastName,
    societe: profile.societe,
    vat_number: profile.vatNumber,
    rue: profile.rue,
    zip_code: profile.zipCode,
    city: profile.city,
    country: profile.country,
    phone_mobile: profile.phoneMobile,
  } as UsersUpdateInputItem;
  return saveMyProfile(payload);
};

export const useOnboardingProfile = () => ({
  profile: readonly(profile),
  profileRaw: profile,
  loaded,
  loading,
  preload,
  saveProfile,
});
